<template>
    <v-content>
        <v-container>
            <v-layout row justify-space-between>
                <v-flex xs2 md1 align-self-center>
                    <v-img :src="logoSrc" aspect-ratio="1.2388888889"></v-img>
                </v-flex>
                <v-flex xs10 md11>
                    <div class="pl-2">
                        <h1>Guild Ops Dashboard</h1>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container grid-list-lg>
            <v-layout row wrap justify-space-around fill-height>
                <v-flex xs12 d-flex>
                    <v-card>
                        <v-card-title primary-title>
                        <div>
                            <h3>
                                Known Issues
                            </h3>
                        </div>
                        </v-card-title>
                        <v-card-text>
                            <v-list three-line dense subheader>
                                <v-subheader>GFF Ops</v-subheader>
                                <v-list-tile color="warning">
                                    <v-list-tile-content>
                                        <v-list-tile-title>Editing/Emulating Non-Upgraded Companies</v-list-tile-title>
                                        <v-list-tile-sub-title>Add yourself to the company team, complete the upgrade wizard on the hub, remove yourself from the team.</v-list-tile-sub-title>
                                        <v-list-tile-sub-title>Once upgrade is complete you can emulate. Contact Lighthouse with any issues/questions.</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Logout</v-list-tile-title>
                                        <v-list-tile-sub-title>Logging out of the ops app does <strong>not</strong> log you out of MyGuild.</v-list-tile-sub-title>
                                        <v-list-tile-sub-title>We can either change it so that you do get logged out, or we can keep it the way it is. Feedback to Lighthouse.</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-subheader>MyGuild</v-subheader>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>IE 11 Slow Loading</v-list-tile-title>
                                        <v-list-tile-sub-title>This is a technical limitation of IE11.</v-list-tile-sub-title>
                                        <v-list-tile-sub-title>Advise users it can take a minute to load. Any longer and it is likely a different problem.</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Old Login Links</v-list-tile-title>
                                        <v-list-tile-sub-title>Some users are visiting the old login link (probably bookmarked). This won't work and will cause random errors to be thrown.</v-list-tile-sub-title>
                                        <v-list-tile-sub-title>Advise users to update their bookmarks to https://hub.gff.co.uk</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Private Browsing</v-list-tile-title>
                                        <v-list-tile-sub-title>Private browsing in Safari and Edge is not supported due to technical limitations.</v-list-tile-sub-title>
                                        <v-list-tile-sub-title>Advise users to either switch back to normal browsing, or use a different browser.</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>iOS Content Blockers</v-list-tile-title>
                                        <v-list-tile-sub-title>Using a content blocker on iOS causes the site to be stuck at the loading screen.</v-list-tile-sub-title>
                                        <v-list-tile-sub-title>Advise users to either disable their content blocker, or add https://hub.gff.co.uk to their exception list.</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
  export default {
    name: 'Overview',
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        logoSrc: require('@/assets/logo.png')
      }
    },
  }
</script>

<style scoped>

</style>